// extracted by mini-css-extract-plugin
export default {"required":"Label_required__dQRde"};